/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const CREATE_DISPLAY = gql`
  mutation CreateDisplay($data: CreateDisplayInput!) {
    createDisplay(data: $data) {
      id
      name
      masterCategoryId
      store {
        id
      }
    }
  }
`
